module.exports = __webpack_public_path__ + "static/background-f39fa7307d95e2a8c9fad0b501d79445.svg";